import { render, staticRenderFns } from "./combination.vue?vue&type=template&id=086e8aea&scoped=true&"
import script from "./combination.vue?vue&type=script&lang=ts&"
export * from "./combination.vue?vue&type=script&lang=ts&"
import style0 from "./combination.vue?vue&type=style&index=0&id=086e8aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086e8aea",
  null
  
)

export default component.exports